export enum CURRENCY_LABEL {
	UAH = '₴',
	UAH_TEXT = 'грн.',
	UAH_CODE = 'UAH',
}
